var $e98d595ece150368$exports = {};
$e98d595ece150368$exports = {
    "endTime": `Vrijeme zavr\u{161}etka`,
    "startTime": `Vrijeme po\u{10D}etka`,
    "time": `Vrijeme`
};


export {$e98d595ece150368$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
